import { render, staticRenderFns } from "./ManageEndorsements.vue?vue&type=template&id=98f54a7a&"
import script from "./ManageEndorsements.vue?vue&type=script&lang=js&"
export * from "./ManageEndorsements.vue?vue&type=script&lang=js&"
import style0 from "./ManageEndorsements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports